// --- src/pages/Login.jsx (armazenar token em sessionStorage) ---
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import './Login.css';
import HomeButton from '../components/HomeButton';

export default function Login() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const { username, password } = form;
      const res = await api.post('/auth/login', { username, password });
      // salva em sessionStorage para expirar ao fechar o navegador
      sessionStorage.setItem('token', res.data.token);
      setIsAuthenticated(true);
      setError('');
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao autenticar');
    }
  };

  function handleDestination(destination) {
    if (destination === 'gestao') {
      navigate('/gestao');
    } else {
      navigate('/admin');
    }
  }

  return (
    
    <div className="login-container">
      
      <form onSubmit={handleSubmit} className="login-form">
        <h2>Login</h2>
        
        {error && <p className="error">{error}</p>}
        <label>
          Usuário
          <input
            name="username"
            value={form.username}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Senha
          <input
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            required
          />
        </label>
        <button
  type="submit"
  style={{
    padding: '10px 16px',
    margin: '12px 0',
    borderRadius: '4px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    cursor: 'pointer'
  }}
>
  Entrar
</button>
        <div>  </div>
        <HomeButton /> 

        {isAuthenticated ? (
          <div className="login-destination-picker">
            <p>Escolha para qual módulo deseja acessar:</p>
            <div className="login-destination-picker__actions">
              <button type="button" onClick={() => handleDestination('admin')}>
                Ir para área administrativa
              </button>
              <button type="button" onClick={() => handleDestination('gestao')}>
                Ir para gestão
              </button>
            </div>
          </div>
        ) : null}
      </form>
    </div>
  );
}
